module.exports = __webpack_public_path__ + "media/assets/services_manager/bank_transfer-960be40953ce2191465ae546f1c3a229b2bada7f81be906459718a50b7585306.png";